import { FormBuilder, FormGroup } from '@angular/forms';

export class BuildingHutsIdResponseModel {
  address1: string;
  address2: string;
  address3: string;
  buildingId: string;
  city: string;
  country: string;
  countyCode: string;
  stateCode: string;
  zip: string;
  hutsbuildingId: string;
  hcrbuildingId: string;
  apartments: [];


  constructor(model?: Partial<BuildingHutsIdResponseModel>) {
    if (model && model !== undefined) {
      const def = new BuildingHutsIdResponseModel();
      Object.keys(def).forEach((key: string) => {
        this[key] = model[key] && model[key] !== undefined ?
          model[key] : def[key];
      });
    }
  }

  static asForm(fb: FormBuilder, submitted: boolean): FormGroup {
    return fb.group({
      address1: [{ value: null, disabled: true }],
      address2: [{ value: null, disabled: true }],
      address3: [{ value: null, disabled: true }],
      buildingId: [{ value: null, disabled: true }],
      city: [{ value: null, disabled: true }],
      country: [{ value: null, disabled: true }],
      countyCode: [{ value: null, disabled: true }],
      stateCode: [{ value: null, disabled: true }],
      zip: [{ value: null, disabled: true }],
      hutsbuildingId: [{ value: null, disabled: true }],
      hcrbuildingId: [],
      apartments: []
    });
  }

  static generateForm(fb: FormBuilder, model: BuildingHutsIdResponseModel, submitted: boolean): FormGroup {
    const form = BuildingHutsIdResponseModel.asForm(fb, submitted);
    form.patchValue(model);
    return form;
  }

  static convertFormToModel(form: FormGroup): BuildingHutsIdResponseModel {
    return form.value;
  }
}
